import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ListTeam extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        const { pitAdvancedListTeam } = content;

        // eslint-disable-next-line no-console
        // console.log('pitAdvancedListTeam---pitAdvancedListTeam', pitAdvancedListTeam);

        return (
            <div className={styles.col_w1000} id={styles.advancedListTeam}>
                <h3>
                    <img src="http://y1.ifengimg.com/a/2015/0819/syj/t07.gif" width="118" height="23" />
                </h3>
                {/* 智库频道-研究团队-高级研究员列表 */}
                <ul className={styles.advancedListTeam}>
                    {pitAdvancedListTeam.map((item, index) => (
                        <li key={index} className="clearfix">
                            <div className={styles.pic}>
                                <a href="" target="_blank">
                                    <img src={item.thumbnail} width="92" height="124" />
                                </a>
                            </div>
                            <div className={styles.txt}>
                                <h5>
                                    <a href="" target="_blank">
                                        {item.title}
                                    </a>
                                </h5>
                                <p>{item.summary}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(ListTeam);
